import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import type { Router } from 'vue-router'
import { useGoodsStore } from '@/store/modules/goodsStore'
import { useCommonStatus } from '@/store/modules/commonStaus'
import { useVoucherStore } from '@/store/modules/voucher'
import { CommonConstants } from '@/common/constants'
import { getAllowRoute } from '@/hooks/useGameConfig'
import { manifestMap } from './staticManifest'
import { useNoticeStore } from "@/store/modules/useNoticeStore";

const router = createRouter({
  history: CommonConstants.IS_CN
    ? createWebHashHistory(process.env.VUE_APP_BASE_ROUTE)
    : createWebHistory(process.env.VUE_APP_BASE_ROUTE),
  routes: [
    CommonConstants.DEFAULT_ROUTE,
    {
      path: '/',
      component: () => import('@/layouts/baseLayout.vue'),
      children: [
        {
          path: ':alias',
          name: 'Shop',
          component: () => import('@/views/mall/index.vue')
        }
      ]
    },
    {
      path: '/ios-global-pay',
      name: 'IosGlobalPay',
      component: () => import('@/views/mall/payGoods/iosGlobalPay/iosGlobalPay.vue')
    },
    {
      path: '/subAuth',
      name: 'SubAuth',
      component: () => import('@/views/mall/subProcess/index.vue')
    },
    {
      path: '/authFinish',
      name: 'AuthFinish',
      component: () => import('@/views/mall/subProcess/finish.vue')
    },
    {
      path: '/wechatPay',
      name: 'WechatPay',
      component: () => import('@/views/mall/payGoods/pcQrCode.vue')
    },
    {
      path: '/404', // 使用通配符匹配所有路由
      name: '404',
      component: () => import('@/views/404.vue')
    },
  ]
})

export default router


// 在导出router之后立即执行初始化manifest的函数
initManifest()

/**
 * 初始化manifest文件
 */
function initManifest() {
  // 监听路由变化，更新manifest
  router.afterEach((to) => {
    const manifest = manifestMap[to.path] || manifestMap['/']

    console.log('manifest', manifest)
    updateManifest(manifest)
  })
}

/**
 * 更新manifest文件
 * @param manifest - manifest
 */
function updateManifest(manifest: Record<string, any>) {
  const blob = new Blob([JSON.stringify(manifest)], {
    type: "application/json",
  });
  const blobURL = URL.createObjectURL(blob);

  // 移除原来的 manifest
  const oldLink = document.querySelector("link[rel='manifest']");
  if (oldLink) oldLink.remove();
  console.log('blobURL', blobURL)
  // 插入新的 manifest
  const link = document.createElement("link");
  link.rel = "manifest";
  link.href = blobURL;
  document.head.appendChild(link);
}

/**
 * 创建一个HTTP守卫，当路由切换时取消所有未完成的请求。
 * @param router - 路由对象。
 */
export function createHttpGuard(router: Router) {
  const allowRoute = getAllowRoute()

  router.beforeEach((to, from, next) => {
    const store = useGoodsStore()
    const storeSet = useCommonStatus()
    const storeVoucher = useVoucherStore()
    const storeNotice = useNoticeStore()
    store.payVisible = false // 重置弹窗状态
    storeSet.voucherActivityVisible = false
    storeSet.limitRebateVisible = false
    storeSet.freeGiftSuccessVisible = false
    storeSet.wechatPayVisible = false
    storeSet.paySuccessVisible = false
    storeSet.activityCenterVisible = false
    storeNotice.noticeConf = null // 重置通知配置
    storeVoucher.voucherCenterVisible = false

    if (to.name === 'Shop' && store.currentCartPath !== to.path) {
      store.currentCartPath = to.path
      store.cartGoodsList = []
    }

    if (to.name === 'Shop' && !allowRoute.includes(to.path)) {
      //   访问404
      next({ name: '404' })
      return
    }

    next()
  })
}

